import { Box } from "@mui/material";
import styled from "styled-components";

export const ResetPasswordStyled = styled(Box)`
  padding: 56px;
  @media (max-width: 768px) {
    padding: 24px;
    margin-top: 40px !important;
  }
  .back {
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;

    p {
      font-size: 12px;
      transition: text-decoration 0.2s ease-in-out;
    }

    &:hover p {
      text-decoration: underline;
    }
  }

  .container {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 18px;
    margin-top: 24px;
    .form-wrapper {
      width: 100%;
      max-width: 548px;
    }
    @media (max-width: 768px) {
      width: 100%;
      .form-wrapper {
        width: 100%;
        max-width: unset;
      }
    }
    .title {
      font-weight: 600;
      font-size: 36px;
      color: var(--dark-gray-color);
      @media (max-width: 768px) {
        font-size: 28px;
      }
    }
    .smallText {
      font-size: 13px;
    }

    .buttons-container {
      margin-top: 32px;
      .primary-button {
        display: flex;
      }
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
    gap: 15px;

    margin-top: 25px;
  }

  .success {
    display: flex;
    align-items: center;
    gap: 15px;
    background-color: #a7d3cc;
    padding: 20px;
    width: 600px;
    border-radius: 7px;
    border: px solid black;
    svg {
      color: green;
    }
  }
`;
